export enum TissueUses {
    ASG = "ASG",
    BioApp = "BioApp",
    CairsProcessed = "CAIRS Processed",
    Disposed = "Disposed",
    DisposedImported = "Disposed / Imported",
    DmProcessed = "DM Processed",
    Education = "Education",
    EducationImported = "Education / Imported",
    PcgProcessed = "PCG Processed",
    Research = "Research",
    ReturnToEyeBank = "Return to Eye Bank",
    Stored = "Stored",
    Training = "Training",
    Transplant = "Transplant",
}
